import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

interface DragItem {
  id: any;
  index: number;
}

const ThumbnailContainer = ({
  selectPage,
  canvasUrl,
  classes,
  thumbnail,
  item,
  index,
  style,
  updateIndex
}) => {
  const ref = useRef(null);

  const [{ isDragging }, connectDrag, connectDragPreview] = useDrag({
    type: 'thumbnail',
    item: (): DragItem => ({
      id: item,
      index: index
    }),
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  const [, connectDrop] = useDrop<DragItem>({
    accept: 'thumbnail',
    hover(draggedItem, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      updateIndex(dragIndex, hoverIndex);
      draggedItem.index = hoverIndex;
    }
  });

  // Connect both drag and drop to the same ref
  connectDrag(ref);
  connectDrop(ref);

  // Set preview image
  const previewImage = new Image();
  previewImage.src = canvasUrl;
  connectDragPreview(previewImage);

  return (
    <div style={style} ref={ref}>
      <div
        style={{
          opacity: isDragging ? 0 : 1
        }}
        onClick={() => selectPage(item)}
        key={item}
        className="grid-item"
      >
        <div className={classes}>
          <div style={{ marginBottom: '3px' }}>{thumbnail}</div>
          <span>{`Page ${item}`}</span>
        </div>
      </div>
    </div>
  );
};

export default ThumbnailContainer;
